export default "__VITE_ASSET__CR0Y1qo2__"